// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileImageField = require("./UnifiedProfileImageField.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let ProfilePageProfilePhotoForm = require("./ProfilePageProfilePhotoForm.bs.js");
let UnifiedYourProfilePhotosSettingsQuery_graphql = require("../../__generated__/UnifiedYourProfilePhotosSettingsQuery_graphql.bs.js");
let UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql = require("../../__generated__/UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.bs.js");

let convertVariables = UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedYourProfilePhotosSettingsRemoveAvatarMutation_graphql.node, convertResponse, convertWrapRawResponse);

let RemoveAvatarMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function usePersonalRemoveAvatar() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit(input, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.removeUnifiedAvatar;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

let convertVariables$1 = UnifiedYourProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedYourProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedYourProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedYourProfilePhotosSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedYourProfilePhotosSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfilePhotosSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfilePhotosSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfilePhotosSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedYourProfilePhotosSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfilePhotosSettings(props) {
  let match = use$1(undefined, undefined, undefined, undefined);
  let agent = match.currentlyLoggedInAgent;
  let match$1 = usePersonalRemoveAvatar();
  let save = match$1[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: "Photos",
        rootName: "Your Profile",
        rootUrl: "/account/profile",
        url: "/account/profile/photos"
      }),
      JsxRuntime.jsx(ProfilePageProfilePhotoForm.make, {
        agent: agent.fragmentRefs
      }),
      Stdlib_Option.isSome(agent.profilePhoto) ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          onClick: param => save(undefined, () => {}, param => {}),
          disabled: match$1[1],
          children: "Remove profile photo"
        }) : null,
      match$1[2],
      JsxRuntime.jsx("section", {
        children: JsxRuntime.jsx(UnifiedProfileImageField.make, {
          label: "Featured Portrait",
          helpText: "This is an optional, larger photo that will appear in your marketing profile at full size.",
          url: Stdlib_Option.map(agent.unifiedFeaturedPhoto, photo => photo.url),
          kind: "Featured"
        }),
        className: "space-y-6 border-t border-zinc-200 pt-8"
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedYourProfilePhotosSettings;

exports.RemoveAvatarMutation = RemoveAvatarMutation;
exports.usePersonalRemoveAvatar = usePersonalRemoveAvatar;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
